export default __webpack_public_path__ + "static/media/company-1.de07f7cc.svg";